export default __webpack_public_path__ + "static/media/logout.e30922f6.svg";